import { useMutation } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import { query as getAllCategoriesQuery } from '../queries/useGetAllCategories';

const CREATE_CATEGORY = gql`
  mutation CreateCategory($input: CreateCategoryInput!) {
    createCategory(input: $input) {
      id
      name
    }
  }
`;

export function useCreateCategory() {
  const [createCategoryMutation, { loading }] = useMutation(CREATE_CATEGORY, {
    update: (cache, { data: { createCategory } }) => {
      try {
        const existingData = cache.readQuery({ query: getAllCategoriesQuery });
        if (existingData?.getAllCategories) {
          const newCategories = [
            ...existingData.getAllCategories,
            createCategory,
          ].sort((a, b) => a.name.localeCompare(b.name));
          cache.writeQuery({
            query: getAllCategoriesQuery,
            data: {
              getAllCategories: newCategories,
            },
          });
        }
      } catch (e) {
        // Cache may not have the query yet, that's ok
      }
    },
  });

  const createCategory = async (name, type) => {
    const result = await createCategoryMutation({
      variables: {
        input: { name, ...(type ? { type } : {}) },
      },
    });
    return result.data?.createCategory;
  };

  return { createCategory, loading };
}
